module.exports = __webpack_public_path__ + "images/_/_/shared/images/ranking/2_f52d64f6781aa63cdb02306a7c02a4a6.png";